import {
    FETCH_ERROR,
    FETCH_SUCCESS,
    SIGNOUT_USER_SUCCESS,
    ERROR_OTHERS,

    FETCH_USER_CURRENT_TASK_START,
    CURRENT_TASK_DATA,
    CURRENT_TASK_CURRENT_TIME,
    CURRENT_TASK_RUNNING_TIME,
    FETCH_USER_AFFECTED_TASKS_START,
    USER_AFFECTED_TASKS_DATA,

    END_TASK_START,
    END_TASK_SUCCESS,

    ADD_COMMON_TASK_START,
    ADD_COMMON_TASK_SUCCESS,

    RESET_CURRENT_TASK_START,
    RESET_CURRENT_TASK_SUCCESS,

    FETCH_TASKS_ORDER_START,
    TASKS_ORDER_DATA,

    FETCH_MANAGER_TASKS_START,
    MANAGER_TASKS_DATA,

    SWAP_TASK_START,
    SWAP_TASK_SUCCESS,

    SET_OFFICER_PREFERED_TASKS_FOR_UNIT,
    CURRENT_ACTIONS_QUEUE_DATA

} from "../../constants/ActionsTypes";
import axios from 'util/Api';
import { addActionInQueue, COMMON_TASK_ACTION, END_TASK_ACTION, getActionsQueue, invertRunningTimers, removeActionFromQueue, RESET_ACTION, SET_TASKS_ORDER, SWAP_ACTION } from "util/ActionsQueueManager";
import { saveQueue } from "./ActionsQueue";
import { getUnitTasks, saveUnitTasksOrder, saveUnitTasks, getUnitTasksOrder, saveCurrentTasks, getCurrentTasks } from "util/LocalDataManager";
import { COACHING_COMMON_TASK_VALUE, ISSUE_COMMON_TASK_VALUE, PAUSE_COMMON_TASK_VALUE, UNPAUSE_COMMON_TASK_VALUE } from "constants/ConstantTypesValues";

function computeTimersValueWithLocalData() {
    const localTasks = getCurrentTasks();
    const actionsQueue = getActionsQueue();
    if (actionsQueue.length === 0) {
        // No actions in the queue, return local timers
        return {
            currenttime: localTasks.currenttime,
            runningtime: localTasks.runningtime
        };
    }
    if (localTasks.currenttime === 0 && localTasks.runningtime === 0) {
        return {
            currenttime: 5, // Call API timeout
            runningtime: 0
        };
    }

    let currenttime = 0;
    let runningtime = 0;
    let skipNextUnpause = false;
    // The timer have to be computed from the last task end or reset time
    // We have to remove pause, coaching and swap time
    for (const iTimer of [1, 2]) {
        let timerValue = 0;
        let actionTime = iTimer === 1 ? new Date(new Date().getTime() - localTasks.currenttime * 1000) : new Date(new Date().getTime() - localTasks.runningtime * 1000);
        const lastEndAction = actionsQueue.filter(a => [END_TASK_ACTION, RESET_ACTION].includes(a.action) && a.params.runningTimer === iTimer).slice(-1)[0];
        if (lastEndAction) {
            if (iTimer !== 1 || localTasks.curenttime > 0 || actionTime >= new Date(lastEndAction.time)) {
                // If current time is before last end action for only first timer
                // it's caused by an end action that set running timer in place of current timer
                actionTime = new Date(lastEndAction.time);
            }
        }
        const actionsAfterEnd = actionsQueue.filter(a => a.time >= actionTime && (a.params.runningTimer === iTimer || a.action === SWAP_ACTION) && ![END_TASK_ACTION, RESET_ACTION].includes(a.action));
        if (actionsAfterEnd.length === 0) {
            // No actions after the last end or reset action, timer is computed from the last action time
            timerValue = Math.floor((new Date() - actionTime) / 1000);
        } else {
            // Compute the timer value from the last action time
            for (const action of actionsAfterEnd) {
                if (action.action === COMMON_TASK_ACTION) {
                    if (action.params.commonTask.commonTaskValue === UNPAUSE_COMMON_TASK_VALUE && !skipNextUnpause) {
                        actionTime = new Date(action.time);
                        skipNextUnpause = true;
                    } else if ([PAUSE_COMMON_TASK_VALUE, COACHING_COMMON_TASK_VALUE].includes(action.params.commonTask.commonTaskValue)) {
                        skipNextUnpause = false;
                        timerValue += Math.floor((new Date(action.time) - actionTime) / 1000);
                    } else if (action.params.commonTask.commonTaskValue === ISSUE_COMMON_TASK_VALUE) {
                        // Issue task time is included in the action time, it is not a pause
                        skipNextUnpause = true;
                    }
                } else if (action.action === SWAP_ACTION) {
                    if (action.params.toRunningTimer === iTimer) {
                        skipNextUnpause = true;
                        actionTime = new Date(action.time);
                    } else {
                        skipNextUnpause = false;
                        timerValue += Math.floor((new Date(action.time) - actionTime) / 1000);
                    }
                }
            }
            if (skipNextUnpause) {
                // We compute the rest time if it was not computed yet
                timerValue += Math.floor((new Date() - actionTime) / 1000);
            }
        }
        if (iTimer === 1) {
            currenttime = timerValue;
        } else if (iTimer === 2) {
            runningtime = localTasks.runningtime === 0 ? 0 : timerValue;
        }
    }
    return { currenttime, runningtime };
}

export const fetchCurrentTask = () => {
    return async (dispatch) => {
        const unsavedActions = getActionsQueue()
        if (unsavedActions.length > 0) {
            dispatch({ type: CURRENT_ACTIONS_QUEUE_DATA, payload: unsavedActions.length });
            const localTasks = getCurrentTasks();
            if (localTasks.tasks.length > 0) {
                dispatch({ type: FETCH_SUCCESS });
                dispatch({ type: CURRENT_TASK_DATA, payload: localTasks.tasks });
                const timers = computeTimersValueWithLocalData();
                dispatch({ type: CURRENT_TASK_CURRENT_TIME, payload: timers.currenttime });
                dispatch({ type: CURRENT_TASK_RUNNING_TIME, payload: timers.runningtime });
            }
            return;
        }

        dispatch({ type: FETCH_USER_CURRENT_TASK_START });
        return axios.get('/getcurrenttask', {
            timeout: 5000,
        })
            .then(({ data }) => {
                if (data.result) {
                    dispatch({ type: FETCH_SUCCESS });
                    saveCurrentTasks(
                        data.result.currenttime,
                        data.result.runningtime === 0 ? -1 : data.result.runningtime,
                        data.result.tasks
                    ); // Save current task data to local storage
                    dispatch({ type: CURRENT_TASK_DATA, payload: data.result.tasks });
                    dispatch({ type: CURRENT_TASK_CURRENT_TIME, payload: data.result.currenttime });
                    dispatch({ type: CURRENT_TASK_RUNNING_TIME, payload: data.result.runningtime });
                } else {
                    console.log("payload: data.error", data.error);
                    dispatch({ type: FETCH_ERROR, payload: "Network Error" });
                }
            }).catch(function (error) {
                if (!error.response) {
                    // Request timed out
                    console.log("payload: data.error", error);
                    dispatch({ type: FETCH_ERROR, payload: "Network Error" });
                    const currentTasks = getCurrentTasks(); // Fallback to local data
                    dispatch({ type: CURRENT_TASK_DATA, payload: currentTasks.tasks });
                    const timers = computeTimersValueWithLocalData();
                    dispatch({ type: CURRENT_TASK_CURRENT_TIME, payload: timers.currenttime });
                    dispatch({ type: CURRENT_TASK_RUNNING_TIME, payload: timers.runningtime });
                    dispatch({ type: FETCH_SUCCESS });
                } else if (error.response.status === 401) {
                    localStorage.removeItem("tokenPwa");
                    localStorage.removeItem("user");
                    dispatch({ type: SIGNOUT_USER_SUCCESS });
                } else {
                    dispatch({ type: ERROR_OTHERS, payload: error });
                }
                dispatch({ type: FETCH_ERROR, payload: error.message });
                console.log("Error****:", error.message);
            });
    }
};

export const fetchTasks = (unitId) => {
    return (dispatch) => {
        dispatch({ type: FETCH_USER_AFFECTED_TASKS_START });
        axios.get('/getaffectedtasksforuser', {
            params: {
                unitId: unitId
            },
            timeout: 5000,
        })
            .then(({ data }) => {
                if (data.result) {
                    dispatch({ type: FETCH_SUCCESS });
                    saveUnitTasks(unitId, data.result.tasks); // Save tasks to local storage
                    dispatch({ type: USER_AFFECTED_TASKS_DATA, payload: data.result.tasks });
                } else {
                    console.log("payload: data.error", data.error);
                    dispatch({ type: FETCH_ERROR, payload: "Network Error" });
                }
            }).catch(function (error) {
                if (!error.response) {
                    // Request timed out
                    console.log("payload: data.error", error);
                    dispatch({ type: FETCH_ERROR, payload: "Network Error" });
                    const localTasks = getUnitTasks(unitId); // Fallback to local data
                    if (localTasks.length > 0) {
                        dispatch({ type: USER_AFFECTED_TASKS_DATA, payload: localTasks });
                        dispatch({ type: FETCH_SUCCESS });
                    }
                } else if (error.response.status === 401) {
                    localStorage.removeItem("tokenPwa");
                    localStorage.removeItem("user");
                    dispatch({ type: SIGNOUT_USER_SUCCESS });
                } else {
                    dispatch({ type: ERROR_OTHERS, payload: error });
                }
                dispatch({ type: FETCH_ERROR, payload: error.message });
                console.log("Error****:", error.message);
            });
    }
};

export const endTask = (task, startTime, runningTimer, paramTime) => {
    if (startTime !== undefined && !(typeof startTime == 'object' && startTime instanceof Date)) {
        startTime = new Date(startTime);
    }
    // Time param is given when we save actions from queue
    return async (dispatch) => {
        const time = paramTime || new Date();
        const taskObj = {
            task: task,
            startTime: startTime ? new Date(startTime.getTime() - (startTime.getTimezoneOffset() * 60000)).toISOString().slice(0, -1) : undefined,
            endTime: new Date(time.getTime() - (time.getTimezoneOffset() * 60000)).toISOString().slice(0, -1),
        };

        if (!paramTime) {
            await dispatch(saveQueue());
            if (getActionsQueue().length > 0) {
                // There is still a network error
                const nbActions = addActionInQueue(END_TASK_ACTION, { task, start: startTime, runningTimer }, taskObj.endTime);
                dispatch({ type: CURRENT_ACTIONS_QUEUE_DATA, payload: nbActions });
                const currentLocalTasks = getCurrentTasks();
                if (runningTimer === 1) {
                    currentLocalTasks.currenttime = currentLocalTasks.runningtime;
                    currentLocalTasks.runningtime = -1;
                    invertRunningTimers();
                } else if (runningTimer === 2) {
                    currentLocalTasks.runningtime = -1;
                }
                saveCurrentTasks(currentLocalTasks.currenttime, currentLocalTasks.runningtime, currentLocalTasks.tasks);
                dispatch(fetchCurrentTask());
                return;
            }
        }

        dispatch({ type: END_TASK_START });
        return axios.post('/endtask', taskObj, {
            timeout: 5000
        })
            .then(({ data }) => {
                if (data.result) {
                    if (paramTime) {
                        const nbActions = removeActionFromQueue(END_TASK_ACTION, paramTime);
                        dispatch({ type: CURRENT_ACTIONS_QUEUE_DATA, payload: nbActions });
                    }
                    const currentLocalTasks = getCurrentTasks();
                    if (runningTimer === 1) {
                        currentLocalTasks.currenttime = currentLocalTasks.runningtime;
                        currentLocalTasks.runningtime = -1;
                        invertRunningTimers();
                    } else if (runningTimer === 2) {
                        currentLocalTasks.runningtime = -1;
                    }
                    saveCurrentTasks(currentLocalTasks.currenttime, currentLocalTasks.runningtime, currentLocalTasks.tasks);
                    dispatch(fetchCurrentTask());
                    dispatch({ type: END_TASK_SUCCESS });
                } else {
                    console.log("payload: data.error", data.error);
                    dispatch({ type: FETCH_ERROR, payload: "Network Error" });
                }
            }).catch(function (error) {
                if (!error.response) {
                    // Request timed out
                    console.log("payload: data.error", error);
                    dispatch({ type: FETCH_ERROR, payload: "Network Error" });
                    dispatch({ type: END_TASK_SUCCESS });
                    if (!paramTime) {
                        const nbActions = addActionInQueue(END_TASK_ACTION, { task, start: startTime, runningTimer }, taskObj.endTime);
                        dispatch({ type: CURRENT_ACTIONS_QUEUE_DATA, payload: nbActions });
                        const currentLocalTasks = getCurrentTasks();
                        if (runningTimer === 1) {
                            currentLocalTasks.currenttime = currentLocalTasks.runningtime;
                            currentLocalTasks.runningtime = -1;
                            invertRunningTimers();
                        } else if (runningTimer === 2) {
                            currentLocalTasks.runningtime = -1;
                        }
                        saveCurrentTasks(currentLocalTasks.currenttime, currentLocalTasks.runningtime, currentLocalTasks.tasks);
                        dispatch(fetchCurrentTask());
                    } else {
                        throw new Error("Network Error");
                    }
                } else if (error.response.status === 401) {
                    localStorage.removeItem("tokenPwa");
                    localStorage.removeItem("user");
                    dispatch({ type: SIGNOUT_USER_SUCCESS });
                } else {
                    dispatch({ type: ERROR_OTHERS, payload: error });
                }
                dispatch({ type: FETCH_ERROR, payload: error.message });
                console.log("Error****:", error.message);
            });
    }
};

export const addCommonTask = (commonTask, runningTimer, paramTime) => {
    // Time param is given when we save actions from queue
    return async (dispatch) => {
        const time = paramTime || new Date();
        const taskObj = {
            commonTaskValue: commonTask.commonTaskValue,
            time: new Date(time.getTime() - (time.getTimezoneOffset() * 60000)).toISOString().slice(0, -1),
        };

        if (!paramTime) {
            await dispatch(saveQueue());
            if (getActionsQueue().length > 0) {
                // There is still a network error
                const nbActions = addActionInQueue(COMMON_TASK_ACTION, { commonTask, runningTimer }, taskObj.time);
                dispatch({ type: CURRENT_ACTIONS_QUEUE_DATA, payload: nbActions });
                return;
            }
        }

        dispatch({ type: ADD_COMMON_TASK_START });
        return axios.post('/addcommontask', taskObj, {
            timeout: 5000
        })
            .then(({ data }) => {
                if (data.result) {
                    if (paramTime) {
                        const nbActions = removeActionFromQueue(COMMON_TASK_ACTION, paramTime);
                        dispatch({ type: CURRENT_ACTIONS_QUEUE_DATA, payload: nbActions });
                    }
                    dispatch({ type: ADD_COMMON_TASK_SUCCESS });
                } else {
                    console.log("payload: data.error", data.error);
                    dispatch({ type: FETCH_ERROR, payload: "Network Error" });
                }
            }).catch(function (error) {
                if (!error.response) {
                    // Request timed out
                    console.log("payload: data.error", error);
                    dispatch({ type: FETCH_ERROR, payload: "Network Error" });
                    dispatch({ type: ADD_COMMON_TASK_SUCCESS });
                    if (!paramTime) {
                        const nbActions = addActionInQueue(COMMON_TASK_ACTION, { commonTask, runningTimer }, taskObj.time);
                        dispatch({ type: CURRENT_ACTIONS_QUEUE_DATA, payload: nbActions });
                    } else {
                        throw new Error("Network Error");
                    }
                } else if (error.response.status === 401) {
                    localStorage.removeItem("tokenPwa");
                    localStorage.removeItem("user");
                    dispatch({ type: SIGNOUT_USER_SUCCESS });
                } else {
                    dispatch({ type: ERROR_OTHERS, payload: error });
                }
                dispatch({ type: FETCH_ERROR, payload: error.message });
                console.log("Error****:", error.message);
            });
    }
};

export const resetCurrentTask = (runningTimer, paramTime) => {
    // Time param is given when we save actions from queue
    return async (dispatch) => {
        const time = paramTime || new Date();
        const params = {
            time: new Date(time.getTime() - (time.getTimezoneOffset() * 60000)).toISOString().slice(0, -1),
        };

        if (!paramTime) {
            await dispatch(saveQueue());
            if (getActionsQueue().length > 0) {
                // There is still a network error
                const nbActions = addActionInQueue(RESET_ACTION, { runningTimer }, params.time);
                dispatch({ type: CURRENT_ACTIONS_QUEUE_DATA, payload: nbActions });
                const currentLocalTasks = getCurrentTasks();
                if (runningTimer === 1) {
                    currentLocalTasks.currenttime = 0;
                } else if (runningTimer === 2) {
                    currentLocalTasks.runningtime = 0;
                }
                saveCurrentTasks(currentLocalTasks.currenttime, currentLocalTasks.runningtime, currentLocalTasks.tasks);
                return;
            }
        }

        dispatch({ type: RESET_CURRENT_TASK_START });
        return axios.post('/resetcurrenttask', params, {
            timeout: 5000,
        })
            .then(({ data }) => {
                if (data.result) {
                    if (paramTime) {
                        const nbActions = removeActionFromQueue(RESET_ACTION, paramTime);
                        dispatch({ type: CURRENT_ACTIONS_QUEUE_DATA, payload: nbActions });
                    }
                    const currentLocalTasks = getCurrentTasks();
                    if (runningTimer === 1) {
                        currentLocalTasks.currenttime = 0;
                    } else if (runningTimer === 2) {
                        currentLocalTasks.runningtime = 0;
                    }
                    saveCurrentTasks(currentLocalTasks.currenttime, currentLocalTasks.runningtime, currentLocalTasks.tasks);
                    dispatch({ type: RESET_CURRENT_TASK_SUCCESS });
                } else {
                    console.log("payload: data.error", data.error);
                    dispatch({ type: FETCH_ERROR, payload: "Network Error" });
                }
            }).catch(function (error) {
                if (!error.response) {
                    // Request timed out
                    console.log("payload: data.error", error);
                    dispatch({ type: FETCH_ERROR, payload: "Network Error" });
                    dispatch({ type: RESET_CURRENT_TASK_SUCCESS });
                    if (!paramTime) {
                        const nbActions = addActionInQueue(RESET_ACTION, { runningTimer }, params.time);
                        dispatch({ type: CURRENT_ACTIONS_QUEUE_DATA, payload: nbActions });
                        const currentLocalTasks = getCurrentTasks();
                        if (runningTimer === 1) {
                            currentLocalTasks.currenttime = 0;
                        } else if (runningTimer === 2) {
                            currentLocalTasks.runningtime = 0;
                        }
                        saveCurrentTasks(currentLocalTasks.currenttime, currentLocalTasks.runningtime, currentLocalTasks.tasks);
                    } else {
                        throw new Error("Network Error");
                    }
                } else if (error.response.status === 401) {
                    localStorage.removeItem("tokenPwa");
                    localStorage.removeItem("user");
                    dispatch({ type: SIGNOUT_USER_SUCCESS });
                } else {
                    dispatch({ type: ERROR_OTHERS, payload: error });
                }
                dispatch({ type: FETCH_ERROR, payload: error.message });
                console.log("Error****:", error.message);
            });
    }
};

export const fetchTasksOrder = (unitId) => {
    return (dispatch) => {
        dispatch({ type: FETCH_TASKS_ORDER_START });
        axios.get('/getofficerpreferedtasksforunit', {
            params: {
                unitId: unitId
            },
            timeout: 5000,
        })
            .then(({ data }) => {
                if (data.result) {
                    dispatch({ type: FETCH_SUCCESS });
                    saveUnitTasksOrder(unitId, data.result.preferedOrder); // Save tasks order to local storage
                    dispatch({ type: TASKS_ORDER_DATA, payload: data.result.preferedOrder });
                } else {
                    console.log("payload: data.error", data.error);
                    dispatch({ type: FETCH_ERROR, payload: "Network Error" });
                }
            }).catch(function (error) {
                if (!error.response) {
                    // Request timed out
                    console.log("payload: data.error", error);
                    dispatch({ type: FETCH_ERROR, payload: "Network Error" });
                    const localTasksOrder = getUnitTasksOrder(unitId); // Fallback to local data
                    if (localTasksOrder) {
                        dispatch({ type: TASKS_ORDER_DATA, payload: localTasksOrder });
                        dispatch({ type: FETCH_SUCCESS });
                    }
                } else if (error.response.status === 401) {
                    localStorage.removeItem("tokenPwa");
                    localStorage.removeItem("user");
                    dispatch({ type: SIGNOUT_USER_SUCCESS });
                } else {
                    dispatch({ type: ERROR_OTHERS, payload: error });
                }
                dispatch({ type: FETCH_ERROR, payload: error.message });
                console.log("Error****:", error.message);
            });
    }
};

export const fetchManagerTasks = (unitId) => {
    return (dispatch) => {
        dispatch({ type: FETCH_MANAGER_TASKS_START });
        axios.get('/getofficertasksforunit', {
            params: {
                unitId: unitId
            }
        })
            .then(({ data }) => {

                if (data.result) {
                    dispatch({ type: FETCH_SUCCESS });
                    dispatch({ type: MANAGER_TASKS_DATA, payload: data.result.officertasks });
                } else {
                    console.log("payload: data.error", data.error);
                    dispatch({ type: FETCH_ERROR, payload: "Network Error" });
                }
            }).catch(function (error) {
                if (error.response.status === 401) {
                    localStorage.removeItem("tokenPwa");
                    localStorage.removeItem("user");
                    dispatch({ type: SIGNOUT_USER_SUCCESS });
                } else {
                    dispatch({ type: ERROR_OTHERS, payload: error });
                }
                dispatch({ type: FETCH_ERROR, payload: error.message });
                console.log("Error****:", error.message);
            });
    }
};

export const swapTask = (toRunningTimer, paramTime) => {
    // Time param is given when we save actions from queue
    return async (dispatch) => {
        const time = paramTime || new Date();
        const params = {
            time: new Date(time.getTime() - (time.getTimezoneOffset() * 60000)).toISOString().slice(0, -1),
        };

        if (!paramTime) {
            await dispatch(saveQueue());
            if (getActionsQueue().length > 0) {
                // There is still a network error
                const nbActions = addActionInQueue(SWAP_ACTION, { toRunningTimer }, params.time);
                dispatch({ type: CURRENT_ACTIONS_QUEUE_DATA, payload: nbActions });
                if (toRunningTimer === 2) {
                    const currentLocalTasks = getCurrentTasks();
                    if (currentLocalTasks.runningtime === 0) {
                        saveCurrentTasks(currentLocalTasks.currenttime, 0, currentLocalTasks.tasks);
                    }
                }
                return;
            }
        }

        dispatch({ type: SWAP_TASK_START });
        return axios.post('/swaptask', params, {
            timeout: 5000,
        })
            .then(({ data }) => {
                if (data.result) {
                    if (paramTime) {
                        const nbActions = removeActionFromQueue(SWAP_ACTION, paramTime);
                        dispatch({ type: CURRENT_ACTIONS_QUEUE_DATA, payload: nbActions });
                    }
                    if (toRunningTimer === 2) {
                        const currentLocalTasks = getCurrentTasks();
                        if (currentLocalTasks.runningtime === 0) {
                            // Start the running timer if it was turned off
                            saveCurrentTasks(currentLocalTasks.currenttime, 0, currentLocalTasks.tasks);
                        }
                    }
                    dispatch({ type: SWAP_TASK_SUCCESS });
                } else {
                    console.log("payload: data.error", data.error);
                    dispatch({ type: FETCH_ERROR, payload: "Network Error" });
                }
            }).catch(function (error) {
                if (!error.response) {
                    // Request timed out
                    console.log("payload: data.error", error);
                    dispatch({ type: FETCH_ERROR, payload: "Network Error" });
                    dispatch({ type: SWAP_TASK_SUCCESS });
                    if (!paramTime) {
                        const nbActions = addActionInQueue(SWAP_ACTION, { toRunningTimer }, params.time);
                        dispatch({ type: CURRENT_ACTIONS_QUEUE_DATA, payload: nbActions });
                        if (toRunningTimer === 2) {
                            const currentLocalTasks = getCurrentTasks();
                            if (currentLocalTasks.runningtime === 0) {
                                saveCurrentTasks(currentLocalTasks.currenttime, 0, currentLocalTasks.tasks);
                            }
                        }
                    } else {
                        throw new Error("Network Error");
                    }
                } else if (error.response.status === 401) {
                    localStorage.removeItem("tokenPwa");
                    localStorage.removeItem("user");
                    dispatch({ type: SIGNOUT_USER_SUCCESS });
                } else {
                    dispatch({ type: ERROR_OTHERS, payload: error });
                }
                dispatch({ type: FETCH_ERROR, payload: error.message });
                console.log("Error****:", error.message);
            });
    }
};

export const setofficerpreferedtasksforunit = (unitId, tasksOrder, paramTime) => {
    return async (dispatch) => {
        const time = paramTime || new Date();
        const timeOffset = new Date(time.getTime() - (time.getTimezoneOffset() * 60000)).toISOString().slice(0, -1)
        if (!paramTime) {
            await dispatch(saveQueue());
            if (getActionsQueue().length > 0) {
                // There is still a network error
                const nbActions = addActionInQueue(SET_TASKS_ORDER, { unitId, tasksOrder }, timeOffset);
                dispatch({ type: CURRENT_ACTIONS_QUEUE_DATA, payload: nbActions });
                dispatch({ type: TASKS_ORDER_DATA, payload: tasksOrder });
                saveUnitTasksOrder(unitId, tasksOrder); // Save tasks order to local storage
                dispatch({ type: SET_OFFICER_PREFERED_TASKS_FOR_UNIT });
                return;
            }
        }

        return axios.post('/setofficerpreferedtasksforunit', {
            unitId: unitId,
            officerPreferedTasksOrderForUnit: tasksOrder
        }, { timeout: 5000 })
            .then(({ data }) => {
                if (data.result) {
                    if (paramTime) {
                        const nbActions = removeActionFromQueue(SET_TASKS_ORDER, paramTime);
                        dispatch({ type: CURRENT_ACTIONS_QUEUE_DATA, payload: nbActions });
                    }
                    saveUnitTasksOrder(unitId, tasksOrder); // Save tasks order to local storage
                    dispatch({ type: TASKS_ORDER_DATA, payload: tasksOrder });
                    dispatch({ type: SET_OFFICER_PREFERED_TASKS_FOR_UNIT });
                } else {
                    console.log("payload: data.error", data.error);
                    dispatch({ type: FETCH_ERROR, payload: "Network Error" });
                }
            }).catch(function (error) {
                if (!error.response) {
                    // Request timed out
                    console.log("payload: data.error", error);
                    dispatch({ type: FETCH_ERROR, payload: "Network Error" });
                    if (!paramTime) {
                        const nbActions = addActionInQueue(SET_TASKS_ORDER, { unitId, tasksOrder }, timeOffset);
                        dispatch({ type: CURRENT_ACTIONS_QUEUE_DATA, payload: nbActions });
                        dispatch({ type: TASKS_ORDER_DATA, payload: tasksOrder });
                        saveUnitTasksOrder(unitId, tasksOrder); // Save tasks order to local storage
                        dispatch({ type: SET_OFFICER_PREFERED_TASKS_FOR_UNIT });
                    } else {
                        throw new Error("Network Error");
                    }
                } else if (error.response.status === 401) {
                    localStorage.removeItem("tokenPwa");
                    localStorage.removeItem("user");
                    dispatch({ type: SIGNOUT_USER_SUCCESS });
                } else {
                    dispatch({ type: ERROR_OTHERS, payload: error });
                }
                dispatch({ type: FETCH_ERROR, payload: error.message });
                console.log("Error****:", error.message);
            });
    }
};